module.exports = __webpack_public_path__ + "static/media/loop-project-hero.d69205a5.png";